import {css} from '@yandex-delivery/blocks/theme/css'

export const subTitle = css`
  opacity: 0.5;
`
